export default __webpack_public_path__ + "static/media/hero-video-en.a398a21c.webm";